import { cn } from '@/lib/utils'
import { formatNumber, formatUSD } from '@/lib/format-utils'

export const countryColumn = {
  id: 'country',
  header: '#',
  accessorFn: (row) => row.country,
  cell: (row) => {
    const country = row.getValue()
    return <div>{country}</div>
  },
  meta: {
    sticky: true,
    stickyLeft: 'left-[0px]',
  },
}

export const pidColumn = (p) => ({
  id: `pid-profit-${p.code}`,
  header: `${p.name}`,
  accessorFn: (row) => {
    const baseline = row.baselines?.[p.code]
    const profit = typeof baseline === 'object' ? baseline?.value : baseline
    return { pid: p.code, profit, baseline }
  },
  cell: (row) => {
    const { profit } = row.getValue()

    // 如果profit不存在,返回null
    if (profit === null || profit === undefined) {
      return null
    }

    const formatted = formatUSD(profit, 0, 0)

    return (
      <div className="text-right">
        {formatted}
      </div>
    )
  },
})
